import { Outlet } from "react-router-dom";
import { UnsavedChangesProvider } from "@/shared/unsaved-changes/UnsavedChanges";
import { AppShellProvider } from "@/shell/AppShellProvider";

/**
 * Antes era `app/layout.tsx` do Next, que também renderizava `<html>` e
 * `<body>`. Isso agora é do `index.html`; aqui sobrou só o provider.
 */
export function RootLayout() {
  return (
    <AppShellProvider>
      <UnsavedChangesProvider>
        <Outlet />
      </UnsavedChangesProvider>
    </AppShellProvider>
  );
}
